import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable, of, tap } from 'rxjs';

import { UserApiService } from './api/services/user-api.service';
import { AuthService } from './auth/auth.service';
import { UserStorageService } from './shared/services/user/user-storage.service';
import { UserUtils } from './shared/services/user/user.utils';

export function appInit(): Observable<void> {
  handleReturnRedirect();
  registerSvgIcons();
  setDefaultTranslation();

  return getUserProfile();
}

function handleReturnRedirect(): void {
  const authService = inject(AuthService);

  authService.handleSSOReturnRedirect();
}

function registerSvgIcons(): void {
  const iconRegistry = inject(MatIconRegistry);
  const sanitizer = inject(DomSanitizer);

  iconRegistry.addSvgIconResolver((name) =>
    sanitizer.bypassSecurityTrustResourceUrl(`icons/${name}.svg`),
  );
}

function setDefaultTranslation(): void {
  const translate = inject(TranslateService);
  translate.use('en');
}

function getUserProfile(): Observable<void> {
  const authService = inject(AuthService);
  const userApiService = inject(UserApiService);
  const userStorageService = inject(UserStorageService);

  if (authService.isSignedOut()) {
    return of(void 0);
  }

  return userApiService.getProfile().pipe(
    tap(profileResponse => {
      const profile = UserUtils.toProfile(profileResponse);
      userStorageService.setProfile(profile);
    }),
    map(() => void 0),
    catchError((error: unknown) => {
      const isForbiddenError = error instanceof HttpErrorResponse
        && error.status === HttpStatusCode.Forbidden;

      if (isForbiddenError) {
        authService.logout();
      }

      return of(void 0);
    }),
  );
}
